/* eslint-disable global-require */
/* eslint-disable spaced-comment */
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2018 Adobe Systems Incorporated
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
import { isMoversFlow, TechFlow, eagleCPCFlow, isCPCCheckAvailabilityFlow, isComboFlow, isExternalFlow, whwTech } from './components/common/Helpers';

require('./components/Page');

// Pages
//require('./pages/Welcome/Welcome');

// page for testing common components
require('./pages/testComponents/aemContainers/testComponent');

// Base Template
require('./pages/BaseTemplate/aemContainers/baseTemplate');

if (isMoversFlow()) {
  //Movers
  // Movers Plans page
  // require('./pages/Movers/MoversPlans/aemContainers/index');
  // require('./pages/Movers/MoversPlans/aemContainers/heading');
  // require('./pages/Movers/MoversPlans/aemContainers/subHeading');
  // require('./pages/Movers/MoversPlans/aemContainers/nextSteps');
  // require('./pages/Movers/MoversPlans/aemContainers/currentPlan');

  // Movers Setup page
  // require('./pages/Movers/MoversSetup/aemContainers/index');
  // require('./pages/Movers/MoversSetup/aemContainers/heading');
  // require('./pages/Movers/MoversSetup/aemContainers/setupOptions');

  // Movers Appointment page
  require('./pages/Movers/MoversAppointment/aemContainers/index');
  // require('./pages/Movers/MoversAppointment/aemContainers/heading');
  // require('./pages/Movers/MoversAppointment/aemContainers/planDetails');
  // require('./pages/Movers/MoversAppointment/aemContainers/professionalSetup');
  // require('./pages/Movers/MoversAppointment/aemContainers/tos.js');
  // require('./pages/Movers/MoversAppointment/aemContainers/appointmentReminder');
  // require('./pages/Movers/MoversAppointment/aemContainers/suspendCheckModal');

  // Movers Confirmation page
  require('./pages/Movers/MoversConfirmation/aemContainers/index');
  // require('./pages/Movers/MoversConfirmation/aemContainers/heading');
  // require('./pages/Movers/MoversConfirmation/aemContainers/subHeading');
  // require('./pages/Movers/MoversConfirmation/aemContainers/setUp');
  // require('./pages/Movers/MoversConfirmation/aemContainers/list');

  // Movers Covid page
  // require('./pages/Movers/MoversCovid/aemContainers/index');
  // require('./pages/Movers/MoversCovid/aemContainers/heading');
  // require('./pages/Movers/MoversCovid/aemContainers/subHeading');
  // require('./pages/Movers/MoversCovid/aemContainers/covidFormDetails');

  //Movers Review order Page

  require('./pages/Movers/MoversOrderReview/aemContainers/index');
  // require('./pages/Movers/MoversOrderReview/aemContainers/heading');
  // require('./pages/Movers/MoversOrderReview/aemContainers/setUp');
  // require('./pages/Movers/MoversOrderReview/aemContainers/dueToday');
  // require('./pages/Movers/MoversOrderReview/aemContainers/dueMonthly');

  // Movers Plans OverView Page
  require('./pages/Movers/MoversPlansOverview/aemContainers/index');
}
// else if (isEUPFlow() === 'true') {
//   //Upgrade Flow
//   // EUP Router Upgrade
//   require('./pages/EUP/deviceSetup/aemContainers/index');
//   require('./pages/EUP/cart/aemContainers/index');
//   require('./pages/EUP/orderReview/aemContainers/index');
//   require('./pages/EUP/confirmation/aemContainers/index');
//   require('./pages/EUP/pendingOrder/aemContainers/index');
//   require('./pages/EUP/expresscart/aemContainers/index');
// }
else if (TechFlow() === 'true') {
  //Tech Flow
  // Technician C-BAND
  require('./pages/Tech/landing/aemContainers/index');
  require('./pages/Tech/sendLink/aemContainers/index');
  require('./pages/Tech/techExpressCart/aemContainers/index');
} else if (eagleCPCFlow() === 'true') {
  require('./pages/CPC/cpcLanding/aemContainers/index');
  require('./pages/CPC/cpcSendLink/aemContainers/index');
  require('./pages/CPC/cpcExpressCart/aemContainers/index');
  require('./pages/CPC/cpcVerifyPin/aemContainers/index');
  require('./pages/CPC/cpcReviewOrder/aemContainers/index');
  require('./pages/CPC/cpcOrderConfirmation/aemContainers/index');
  require('./pages/CPC/cpcPlanInfo/aemContainers/index');
  require('./pages/CPC/cpcLoading/aemContainers/index');
  // require('./pages/CPC/cpcCreditCheck/aemContainers/index');
} else if (whwTech() === 'true') {
  require('./pages/whwTech/whwLanding/aemContainers/index.js');
  require('./pages/whwTech/whwSendLink/aemContainers/index');
  require('./pages/whwTech/whwExpressCart/aemContainers/index');
  require('./pages/whwTech/whwVerifyPin/aemContainers/index');
  require('./pages/whwTech/whwReviewOrder/aemContainers/index');
  require('./pages/whwTech/whwOrderConfirmation/aemContainers/index');
  require('./pages/whwTech/whwLoading/aemContainers/index');
} else if (isCPCCheckAvailabilityFlow() === true) {
  require('./pages/AddressQual/aemContainers/AddressQual');
} else if (isComboFlow()) {
  require('./pages/Combo/aemContainers/index');
} else if (isExternalFlow()) {
  require('./pages/External/aemContainers/index');
} else {
  //web

  // Streaming Devices Page
  require('./pages/Addons/aemContainers/web/addons');
  require('./pages/Addons/aemContainers/web/heading');
  //require('./pages/Addons/aemContainers/web/addonPromotions');
  //require('./pages/Addons/aemContainers/web/streamingService');
  require('./pages/Addons/aemContainers/web/streamingDevice');
  //require('./pages/Addons/aemContainers/web/voiceService');
  //require('./pages/Addons/aemContainers/web/vzProtectHome');
  require('./pages/Addons/aemContainers/web/addonProducts');

  // Device Setup Page
  require('./pages/DeviceSetup/aemContainers/web/deviceSetup');
  require('./pages/DeviceSetup/aemContainers/web/deviceSetUpHeading');
  // require('./pages/DeviceSetup/aemContainers/setupDescription')
  // require('./pages/DeviceSetup/aemContainers/setupType')
  // require('./pages/DeviceSetup/aemContainers/setupImagesAndDescription')
  require('./pages/DeviceSetup/aemContainers/web/deviceSetupOptions');

  // Cart Page
  require('./pages/Cart/aemContainers/web/estimatedBillSummary');
  require('./pages/Cart/aemContainers/web/saveCart');
  require('./pages/Cart/aemContainers/web/resumeCartAAL');
  require('./pages/Cart/aemContainers/web/cart');
  require('./pages/Cart/aemContainers/web/dueMonthly');
  require('./pages/Cart/aemContainers/web/dueToday');
  require('./pages/Cart/aemContainers/web/cartHeader');
  require('./pages/Cart/aemContainers/web/cartAddons');

  // Contact Info Page
  require('./pages/ContactInfo/aemContainers/web/index');
  require('./pages/ContactInfo/aemContainers/web/heading');
  require('./pages/ContactInfo/aemContainers/web/contactInformation');
  require('./pages/ContactInfo/aemContainers/web/billingInfo');
  require('./pages/ContactInfo/aemContainers/web/secureAccountPin');

  // Contact Info - New Page
  require('./pages/ContactInformation/aemContainers/index');

  // Payment Info Page
  require('./pages/PaymentInfo/aemContainers/web/paymentInfo');
  require('./pages/PaymentInfo/aemContainers/web/paymentTypes');

  // Shipping Info Page
  require('./pages/ShippingInfo/aemContainers/web/shippingInfo');
  require('./pages/ShippingInfo/aemContainers/web/shippingOptions');
  require('./pages/ShippingInfo/aemContainers/web/ShippingAdress');
  require('./pages/ShippingInfo/aemContainers/web/ShippingHeader');
  require('./pages/ShippingInfo/aemContainers/web/ShippingSubHeader');

  // Terms And Conditions Page
  //require('./pages/TermsAndConditions/aemContainers/web/index');
  // require('./pages/TermsAndConditions/aemContainers/web/tosSection');

  // Review Order Page
  require('./pages/ReviewOrderPage/aemContainers/web/index');
  // require('./pages/ReviewOrderPage/aemContainers/web/tos');
  // require('./pages/ReviewOrderPage/aemContainers/web/shippingInfo');
  // require('./pages/ReviewOrderPage/aemContainers/web/shippingInfoRedesign');
  require('./pages/ReviewOrderPage/aemContainers/web/tosSectionPageVdsRedesign');
  require('./pages/ReviewOrderPage/aemContainers/web/shippingDetailsVdsRedesign');
  require('./pages/ReviewOrderPage/aemContainers/web/estimatedSummaryVdsRedesign');

  // Appointment Schedule Page
  require('./pages/AppointmentSchedule/aemContainers/web/appointmentSchedule');
  //require('./pages/AppointmentSchedule/aemContainers/web/appointmentCalender');
  //require('./pages/AppointmentSchedule/aemContainers/web/appointmentCalenderSelf');
  require('./pages/AppointmentSchedule/aemContainers/web/appointmentCalenderVds');
  require('./pages/AppointmentSchedule/aemContainers/web/appointmentCalenderVdsPro');

  // Order Confirmation Page
  require('./pages/OrderConfirmation/aemContainers/web/index');
  require('./pages/OrderConfirmation/aemContainers/web/confirmationHeading');
  require('./pages/OrderConfirmation/aemContainers/web/subHeading');
  require('./pages/OrderConfirmation/aemContainers/web/setup');
  require('./pages/OrderConfirmation/aemContainers/web/importantSteps');
  require('./pages/OrderConfirmation/aemContainers/web/helpLine');
  require('./pages/OrderConfirmation/aemContainers/web/discounts');
  require('./pages/OrderConfirmation/aemContainers/web/promoTiles');

  // Credit Check Page
  require('./pages/CreditCheck/aemContainers/web/index');
  require('./pages/CreditCheck/aemContainers/web/personalInformation');
  require('./pages/CreditCheck/aemContainers/web/heading');
  require('./pages/CreditCheck/aemContainers/web/subHeading');
  // Credit Hold Page
  require('./pages/CreditStatus/aemContainers/web/index');
  require('./pages/CreditStatus/aemContainers/web/creditStatusContent');

  //Credit downpayment page
  require('./pages/CreditDownPayment/aemContainers/web/downpayment');

  // Credit Check EdgeIneligible Page
  require('./pages/CreditcheckEdgeIneligible/aemContainers/web/index');

  // C -BAND WEB
  require('./pages/CBandPlans/aemContainers/web/index');
  require('./pages/CBandPlans/aemContainers/web/plans');

  // MLP Page
  require('./pages/AddressLookup/aemContainers/AddressLookup');
}

//Common pages
require('./pages/Common/aemContainers/miniCartDueToday');
require('./pages/Common/aemContainers/miniCartDueMonthly');
require('./pages/Common/aemContainers/miniCartDueTodayFunc');
require('./pages/Common/aemContainers/miniCartDueMonthlyFunc');
require('./pages/Common/aemContainers/heading');
require('./pages/Common/aemContainers/subHeading');

// Express Cart
require('./pages/ExpressCart/aemContainers/index');

// Resume Cart
require('./pages/ResumeCart/aemContainers/index');

// paymentPayPalIntermediate
require('./pages/PaymentPayPalIntermediate/aemContainers/index');

// registration page

require('./pages/Registration/aemContainers/index');
require('./pages/Registration/aemContainers/registrationInfo');

// broadbandfacts page
require('./pages/BroadBandFacts/aemContainers/web/index');
require('./pages/AddressSearch/aemContainers/web/index');

// local test page

require('./pages/Test/aemContainers/index');

//DTD - Brtc page
require('./pages/dtd/pages/aemcontainers/brtc');

// Functional components SHIPPING
